function resize() {
  var winHeight = $(window).height();
  $(".modal-autoheight .modal-body").css({
    width: "auto",
    height: (winHeight - 200) + "px"
  });
}

function btnScroll($name){
  $($name).on('click',function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        var targetOffset = $target.offset().top - 75;
        $('html,body').animate({ scrollTop: targetOffset }, 1000);
        return false;
      }
    }
  });
}

// 以下為點擊後滾動至該區塊 : '.scrollLink'  
function scrollLink($name){
  $($name).on('click', function(e) {
      e.preventDefault();
      var target = $(this).attr("href");
      
      $('html, body').stop().animate({ 
        scrollTop: $(target).offset().top
      }, 1000, function() {
        location.hash = target - 300;
      });
      
      return false;
  });
}

// 以下為主連結在滾動後的effect
function startScroll(){
  var header = $(".start-style");
  $(window).on('scroll',function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
      header.removeClass('start-style').addClass("scroll-on");
    } else {
      header.removeClass("scroll-on").addClass('start-style');
    }
  });
}

// 取得頁面寬度
function viewport() {
  var e = window,
      a = 'inner';
  if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
  }
  return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

$(function() {
  //以下為Menu On Hover
	$('body').on('mouseenter mouseleave','.nav-item',function(e){
      if ($(window).width() > 750) {
        var _d=$(e.target).closest('.nav-item');_d.addClass('show');
        setTimeout(function(){
          _d[_d.is(':hover')?'addClass':'removeClass']('show');
        },1);
      }
  });
  
  // 以下為Gotop
  $(".float-link .link-btn.top").on('click',function () {
    $("html,body").animate({ "scrollTop": "0" })
  });

  $(window).on("load resize scroll", function (e) {
    var scroll = $(this).scrollTop();
    var wdh = $(window).height();
    if (scroll > 50) {
        $(".float-link").addClass("active");
    } else {
        $(".float-link").removeClass("active");
    }
  });

  // 打開搜尋bar
  $('.toggle-search').on('click',function() {
    $('.search-formList').toggleClass('open');
    return false;
  });

  function checkEllipsis(name,len){
    $(name).each(function(i){
      if($(this).text().length>len){
          $(this).attr("title",$(this).text());
          let text=$(this).text().substring(0,len-1)+"...";
          $(this).text(text);
      }
    });
  }

  checkEllipsis(".JQellipsis-txt",20);
  checkEllipsis(".JQellipsis",60);
  checkEllipsis(".JQellipsis-blog",80);

  // 以下為Swiper設定
    var bannerSwiper = new Swiper('.bannerSwiper .swiper-container', {
      autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
      },
      keyboard : true,
      virtualTranslate : true,
      on:{
        setTranslate: function(){
          this.$wrapperEl.transition('')
          TweenMax.to(this.$wrapperEl, 1.5, {x:this.translate, ease:Power4.easeOut})
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    var centurySwiper = new Swiper(".about-century .centurySwiper", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 8,
      freeMode: true,
      watchSlidesProgress: true,
      clickable :true,
      breakpoints: { 
        320: {  //当屏幕宽度大于等于320
          slidesPerView: 2,
          spaceBetween: 10
        },
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 3,
          spaceBetween: 20
        },
        1280: {  //当屏幕宽度大于等于1280
          spaceBetween: 10,
          slidesPerView: 8,
        }
      }
    });
    var centurySwiper2 = new Swiper(".about-century .centurySwiper2", {
      loop: false,
      spaceBetween: 0,
      autoHeight: true, //高度随内容变化
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: centurySwiper,
      },
    });

    // 漁光小舖首頁-精選商品
    var shopProswiper = new Swiper(".shopPro-mySwiper", {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      loop: true,
      spaceBetween: 30,
      slidesPerView: 3,
      breakpoints: { 
        320: {  //当屏幕宽度大于等于320
          slidesPerView: 1,
          spaceBetween: 0
        },
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 2,
          spaceBetween: 0
        },
        1280: {  //当屏幕宽度大于等于1280
          spaceBetween: 30,
          slidesPerView: 3,
        }
      }
    });
    var shopProswiper2 = new Swiper(".shopPro-mySwiper2", {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '0' +(index + 1) + '</span>';
        },
      },
      thumbs: {
        swiper: shopProswiper,
      },
    });

    // 漁光小舖的產品詳細
    var shopProd_mySwiper = new Swiper(".shopProd_mySwiper", {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      loop: true,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: { 
        320: {  //当屏幕宽度大于等于320
          slidesPerView: 3,
          spaceBetween: 5
        },
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 3,
          spaceBetween: 0
        },
        1280: {  //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 10
        }
      }
    });
    var shopProd_mySwiper2 = new Swiper(".shopProd_mySwiper2", {
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: shopProd_mySwiper,
      },
    });

    var serSwiper = [];
    if($('.serSwiper').length > 0) {
      $('.serSwiper').each(function(i){
        var num = i + 1;
        serSwiper.push(new Swiper('.js-serSwiper-'+num+' .swiper-container', {
          autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
          },
          keyboard : true,
          virtualTranslate : true,
          on:{
            setTranslate: function(){
              this.$wrapperEl.transition('')
              TweenMax.to(this.$wrapperEl, 1.5, {x:this.translate, ease:Power4.easeOut})
            }
          },
          pagination: {
            el: '.js-serSwiper-'+num+' .swiper-pagination',
            clickable: true,
          },
        }));
      });
    }
  
  // 累積成果的使用
  if($('.js-counter').length > 0){
    let eheight = $(".js-counter").offset().top;
    let windowheight = $(window).scrollTop();
    let wh = $(window).height();
    let jh = eheight - wh / 2;
  
    // CountTo
    let countFun = function(){
      $('.counter').each(function() {
        var $this = $(this),
            countTo = $this.attr('data-count');
        $({ countNum: $this.text()}).animate({
          countNum: countTo
        },{
          duration: 8000,
          easing:'linear',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
          }
      
        });
      });
    }
    
    if (eheight - windowheight < wh / 2) {
      setTimeout(countFun, 0);
    }
    
    $(window).scroll(function () {
      let wS = $(this).scrollTop();
      if (wS > jh) {
        setTimeout(countFun, 0);
      }
    });
  }


  // 在內頁有第二層連結的使用
  if (viewport().width > 1101) {
    if($('.content-nav-dropdown').length > 0){
      $('.pageArticle-title').css('margin-top','6.5em');
    }
  }

  //  地址 購買人
  $("#twzipcode").twzipcode();

  //// ---- Swealert ---- ////
  // addTo cart
  // 參考 : https://codepen.io/designcouch/pen/OJPdZxg?editors=1100
  if($('#addtocart').length > 0) {
    $('#addtocart').on('click',function(){
      var cart = $('#cart');
      var cartTotal = cart.attr('data-totalitems');
      var newCartTotal = parseInt(cartTotal) + 1;
      Swal.fire({
        title: '商品已加入購物車!',
        icon: 'success',
        confirmButtonText: '關閉'
      }).then((result) => {
        setTimeout(function(){
          cart.addClass('visible');
          cart.addClass('shake').attr('data-totalitems', newCartTotal);
          setTimeout(function(){
            cart.removeClass('shake');
          },500)
        },0)
      })
    })
  }

  if($('.cartSend').length > 0) {
    $('.cartSend').on('click',function(){
      Swal.fire({
          title: '訂單已送出!',
          icon: 'success',
          confirmButtonText: '回首頁'
      }).then((result) => {
          window.location.href = "shop_index.html";
      })
    })
  }

  // 自定義JS tab
  const tabsMenu = document.querySelectorAll('.js-tab');
  const tabsPanel = document.querySelectorAll('.js-tabs-panel');

  tabsMenu.forEach(function(data,i){
    data.addEventListener('click',function(){
      // 先定義所有區塊隱藏
      tabsMenu.forEach(function(item){
        item.classList.remove('active')
      });
      tabsPanel.forEach(function(item){
        item.classList.remove('d-block');
      });

      //當前點擊的時候..對應的索引值增加className
      tabsMenu[i].classList.add('active');
      tabsPanel[i].classList.add('d-block')
    });
  })

  //// ---- 以下為call Fun ---- ////
  startScroll();
  btnScroll('.btnScroll');
  scrollLink('.scrollLink' )

});
